import { JSONSchemaType } from "ajv"
import validateConstant, {
  e入力パターン,
} from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TPaymentRegisterListPutReqValidate } from "./TPayment"

export const TPaymentRegisterListPutReqSchema: JSONSchemaType<TPaymentRegisterListPutReqValidate> =
  {
    type: "object",
    properties: {
      支払合計備考: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "備考",
        errorMessage: util.stringErrorMessage("備考", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
      支払処理状態区分コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.汎用区分コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "支払処理状態",
        errorMessage: util.stringErrorMessage("支払処理状態", {
          required: true,
          maxLength: validateConstant.LENGTH.汎用区分コード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
    },
    required: ["支払処理状態区分コード"],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        "支払処理状態区分コード",
      ]),
    },
  }
